





























































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import modalState from "@/common/store/modules/modalState";

import { getUserRoles } from "@/admin/store/api";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    IconBase,
    IconArrowBottom
  },
  filters: {
    truncate(value: any, length = 20, omission = "...") {
      if (value.length <= length) {
        return value;
      }
      return value.substring(0, length) + omission;
    }
  }
})
export default class HeaderGroupNavi extends Vue {
  iconColor = "#000000";
  textColor = "#000000";
  trimTextLength = 20;
  idPrefix = "groups";
  buttonWidth = "auto";

  value!: any;

  shown = false;
  switchState = false;

  groups: Array<any> = [];
  groupId = 0;
  groupLabel = "";
  headerInfo = commons.headerInfo;

  get zIndexStyle() {
    const { shown } = this;
    const zIndex = shown ? 2 : 0;

    return { zIndex };
  }

  get buttonClass() {
    const { buttonWidth } = this;
    const classNameBase = "p-header-group-navi__heading";
    const resultIndex = buttonWidth === "auto" ? "auto" : "other";
    const resultClassName = {
      auto: [`${classNameBase}--group`],
      other: [`${classNameBase}--search`]
    };

    return resultClassName[resultIndex];
  }

  get closeModalState() {
    return modalState.closeModalState;
  }

  @Watch("closeModalState")
  onCloseModalState() {
    this.shown = false;
  }

  setGroupLabel() {
    for (let i = 0; i < this.groups.length; i++) {
      if (this.groups[i].id === this.groupId) {
        this.groupLabel = this.groups[i].name;
        break;
      }
    }
  }

  async updateGroupId(id: number, name = "") {
    this.switchShownState();

    if (id !== this.groupId) {
      window.sessionStorage.setItem("selectedGroupId", id + "");
      window.sessionStorage.setItem("isGroupSelected", 1 + "");
      window.sessionStorage.setItem("selectedGroupName", name);
      window.sessionStorage.setItem("groupChangeLevel", 1 + "");

      LocalStorage.removeItem("USER_GROUP_ROLE_PERMISSIONS");
      LocalStorage.setItem("USER_GROUP_ID", id + "");

      const roles: any = await getUserRoles();
      LocalStorage.setItem("USER_ROLES", JSON.stringify(roles));

      this.groupId = id;
      this.setGroupLabel();

      this.$nextTick(() => {
        window.location.reload();
      });
    }
  }

  async created() {
    this.groups = JSON.parse(
      LocalStorage.getItem("USER_GROUPS") as string
    );

    this.groupId = parseInt(
      LocalStorage.getItem("USER_GROUP_ID") as string,
      10
    );

    this.setGroupLabel();

    if (this.groupLabel === "") {
      this.groupLabel = this.groups[0].group_name;
    }
  }

  switchShownState() {
    this.shown = !this.shown;
  }
}
